import api from "./api";
import { parsePaginatedList } from "../utils/pagination";

export interface RecipeIngredient {
  id?: string;
  ingredientProductId: string;
  quantity: number;
  unit: string;
  wastagePercent?: number;
  notes?: string | null;
  ingredientProduct?: { id: string; name: string; unit: string };
}

export interface Recipe {
  id: string;
  productId: string;
  name: string;
  yield: number;
  yieldUnit: string;
  isActive: boolean;
  product?: { id: string; name: string; productType: string; unit: string };
  ingredients?: RecipeIngredient[];
  createdAt?: string;
}

const recipeAPI = {
  getRecipes: async (params?: {
    pageNo?: number;
    pageSize?: number;
    search?: string;
    isActive?: string;
    productId?: string;
  }): Promise<{ data: Recipe[]; total: number }> => {
    const response = await api.get("/recipes", { params });
    return parsePaginatedList<Recipe>(response.data.data);
  },

  getRecipeById: async (id: string): Promise<Recipe> => {
    const response = await api.get(`/recipes/${id}`);
    return response.data.data;
  },

  createRecipe: async (payload: {
    productId: string;
    name: string;
    yield?: number;
    yieldUnit?: string;
    isActive?: boolean;
    ingredients: RecipeIngredient[];
  }): Promise<Recipe> => {
    const response = await api.post("/recipes", payload);
    return response.data.data;
  },

  updateRecipe: async (
    id: string,
    payload: Partial<{
      name: string;
      yield: number;
      yieldUnit: string;
      isActive: boolean;
      ingredients: RecipeIngredient[];
    }>
  ): Promise<Recipe> => {
    const response = await api.put(`/recipes/${id}`, payload);
    return response.data.data;
  },

  deleteRecipe: async (id: string): Promise<void> => {
    await api.delete(`/recipes/${id}`);
  },

  toggleActive: async (id: string): Promise<Recipe> => {
    const response = await api.patch(`/recipes/${id}/toggle-status`);
    return response.data.data;
  },
};

export default recipeAPI;
